export const sizes = {
  mini: '5px',
  tiny: '10px',
  small: '15px',
  medium: '30px',
  large: '60px',
  headerHeight: '90px',
  asideWidth: '300px'
};